import React from "react";
// product: object
// goCart: func - open cart modal
export default function ProductCard({ product, showOldPrice }) {
  const { phrases } = window;
  if (!product) return null;
  const {
    name,
    price,
    // format_price: formatPrice,
    old_price: oldPrice,
    // format_old_price: formatOldPrice,
    image,
    url,
    properties: { size, weight_product: weightProduct } = {},
    vendor_code: vendorCode,
  } = product;

  return (
    <div className="cart-card flex-s">
      <div className="cart-card__img flex-c-c">
        <img
          src={image}
          alt=""
        />
      </div>
      <div className="cart-card__content flex-c">
        <div className="cart-card__info">
          <div className="code flex-c">
            <div className="title">{phrases?.checkout?.productProps?.article || "Article"}:</div>
            <div className="num">{vendorCode}</div>
          </div>
          {url ?
            <a
              href={url}
              className="name"
            >{name}</a>
            :
            <span className="name">{name}</span>
          }
        </div>
        <ul className="cart-card__sizes flex-c">
          {size &&
            <li className="flex-c">
              <div className="title">{phrases?.checkout?.productProps?.size || "Size"}:</div>
              <div className="num">{size}</div>
            </li>}
          {weightProduct &&
            <li className="flex-c">
              <div className="title">{phrases?.checkout?.productProps?.weight || "Weight"}:</div>
              <div className="num">{weightProduct} {phrases?.product?.weight_uom}</div>
            </li>}
        </ul>
        <div className="cart-card__price">
          <span className="price__current">{Number(price).toLocaleString()} ₴</span>
          {showOldPrice && oldPrice && <span className="price__old">{Number(oldPrice).toLocaleString()} ₴</span>}
        </div>
        {/* <div className="cart-card__remove flex-c-c" data-id="2654253">
          <svg className="icon-trash">
            <use xlinkHref="#trash" />
          </svg>
        </div> */}
      </div>
    </div>
  );
}
